var map = {
	"./fonts/MSR500.otf": "10c3",
	"./fonts/MSR700.otf": "7e6a",
	"./fonts/MuseoSansCyrl-100.woff": "f70f",
	"./fonts/MuseoSansCyrl-100.woff2": "989c",
	"./fonts/MuseoSansCyrl-300.woff": "077b",
	"./fonts/MuseoSansCyrl-300.woff2": "8bd4",
	"./fonts/MuseoSansCyrl-500.woff": "3edc",
	"./fonts/MuseoSansCyrl-500.woff2": "c0a4",
	"./fonts/MuseoSansCyrl-700.woff": "95eb",
	"./fonts/MuseoSansCyrl-700.woff2": "5ef2",
	"./fonts/MuseoSansCyrl-900.woff": "531b",
	"./fonts/MuseoSansCyrl-900.woff2": "8672",
	"./images/Bookmark/score-abbr-gradient-blue.png": "6f57",
	"./images/Bookmark/star-gradient-pink.png": "5f0db",
	"./images/LandingDeliveryMap/car.svg": "ed55",
	"./images/LandingDeliveryMap/city.svg": "a0bf",
	"./images/LandingDeliveryMap/earth-dark.svg": "cb88",
	"./images/LandingDeliveryMap/earth.svg": "2990",
	"./images/LandingDeliveryMap/marker.svg": "153b",
	"./images/LandingDeliveryMap/recycle.png": "5489",
	"./images/LandingDeliveryMap/weather-upd.svg": "4f0f",
	"./images/LandingMenuSlider/last.png": "115c",
	"./images/android-mobapp.png": "6b93",
	"./images/app/android.svg": "0445",
	"./images/app/ios.svg": "1835",
	"./images/bonus-rounded.svg": "84cb",
	"./images/bonus_b.png": "fc62",
	"./images/bonuses/bonus_b.png": "b39a",
	"./images/bonuses/bonus_m.png": "3e71",
	"./images/bonuses/bonus_p.png": "beb9",
	"./images/bonuses/star_extrabonus.png": "7ff0",
	"./images/box-img.png": "fbd7",
	"./images/brandbook/intersect.svg": "ddad",
	"./images/check.svg": "51c7",
	"./images/circle-loader.png": "4580",
	"./images/creditCards/aeroflot.svg": "c6bb",
	"./images/creditCards/aeroflot_red.svg": "095d",
	"./images/creditCards/amex.svg": "9577",
	"./images/creditCards/discover.svg": "e34a",
	"./images/creditCards/electron.svg": "3af1",
	"./images/creditCards/electron_gray.svg": "4406",
	"./images/creditCards/maestro.svg": "2cd1",
	"./images/creditCards/maestro_gray.svg": "58e8",
	"./images/creditCards/mastercard.svg": "ca842",
	"./images/creditCards/mastercard_gray.svg": "3a5d",
	"./images/creditCards/mir.svg": "1e34",
	"./images/creditCards/mir_gray.svg": "96b7",
	"./images/creditCards/visa.svg": "7d00",
	"./images/creditCards/visa_gray.svg": "db7e",
	"./images/cross-smooth.svg": "b7c3",
	"./images/download-app-mobile.png": "c028",
	"./images/filters/filters-settings.svg": "3b75",
	"./images/filters/update-modal-icon.png": "3d86",
	"./images/footer.jpg": "9e41",
	"./images/footer/apple_pay.svg": "58fd",
	"./images/footer/cloudpayment.svg": "46c0",
	"./images/footer/google-pay_gray.svg": "d954",
	"./images/footer/halva.svg": "097f",
	"./images/footer/master_card.svg": "a59d",
	"./images/footer/mir-card-pay.svg": "c474",
	"./images/footer/mir-pay.svg": "e9e9",
	"./images/footer/sbp-pay.svg": "3225",
	"./images/footer/visa.svg": "6239",
	"./images/footerV2/payment/apple-pay.svg": "df66",
	"./images/footerV2/payment/googlepay-logo-full.svg": "73a9",
	"./images/footerV2/payment/halva.svg": "1189",
	"./images/footerV2/payment/mastercard.svg": "f511",
	"./images/footerV2/payment/mir-card-pay.svg": "25ca",
	"./images/footerV2/payment/mir-pay.svg": "8513",
	"./images/footerV2/payment/mir.svg": "5b88",
	"./images/footerV2/payment/sbp-pay.svg": "eb69",
	"./images/footerV2/payment/visa.svg": "03b9",
	"./images/footerV2/social/facebook.svg": "c2a1",
	"./images/footerV2/social/instagram.svg": "7230",
	"./images/footerV2/social/vk.svg": "18bf",
	"./images/footerV2/support/call.svg": "6aff",
	"./images/footerV2/support/incoming-call.svg": "db0f",
	"./images/footerV2/support/telegram.svg": "31d5",
	"./images/footerV2/support/whatsapp.svg": "4f08",
	"./images/icons/arrow-down-full.svg": "4056",
	"./images/icons/bell.svg": "ec9c",
	"./images/icons/circle_check.svg": "a7c2",
	"./images/icons/icon-close-small.svg": "5c72",
	"./images/icons/icon_round_chevron_left.svg": "bd6d",
	"./images/icons/icon_round_chevron_right.svg": "96c9",
	"./images/icons/important.svg": "2f3e",
	"./images/icons/info-rounded-small.svg": "82f8",
	"./images/icons/info.svg": "3e95",
	"./images/icons/padlock.svg": "af13",
	"./images/icons/pay-sbp-gray.svg": "4928",
	"./images/icons/pay-sbp.svg": "269f",
	"./images/image-placeholder.svg": "56f0",
	"./images/img-float-button.png": "3abb",
	"./images/imt/imt-icon-1.svg": "9fc2",
	"./images/imt/imt-icon-2.svg": "c627",
	"./images/imt/imt-icon-3.svg": "4803",
	"./images/imt/imt-main.jpg": "b733",
	"./images/ios-mobapp.png": "e164",
	"./images/landingNeeds/high.png": "db67",
	"./images/landingNeeds/medium.png": "e7ce",
	"./images/logo-one-line.svg": "264a",
	"./images/logo-one-line_simple.svg": "1328",
	"./images/logo-two-letters-green.svg": "0335",
	"./images/logo-two-lines.svg": "e4a4",
	"./images/logo-two-lines_simple.svg": "e29c",
	"./images/longate-bonus-bg-desktop.jpg": "1310",
	"./images/longate-bonus-bg-mobile.jpg": "442b",
	"./images/map/dot.png": "a4e9",
	"./images/map/dot2.png": "7505",
	"./images/newOrder/banner_cmz=1ZV7.png": "58aa",
	"./images/newOrder/delivery-box.png": "b4d7",
	"./images/newOrder/empty-pack.svg": "bed4",
	"./images/newOrder/info-icon.svg": "8812",
	"./images/newOrder/welcome-set-success.svg": "483c",
	"./images/offer-images/1.png": "6b4d",
	"./images/offer-images/2.png": "1ae8",
	"./images/offer-images/3.png": "b6ba",
	"./images/offer-images/4.jpeg": "51c2",
	"./images/offer-images/5.jpeg": "2c76",
	"./images/offer-images/6.png": "05fb",
	"./images/offer-images/persent-icon.svg": "d031",
	"./images/order/aeroflot-card.svg": "131c",
	"./images/page404/bg.jpg": "7fa7",
	"./images/page404/bg_mob.jpg": "3812",
	"./images/pageTaro/bg-old.png": "7f22",
	"./images/pageTaro/bg.png": "acc1",
	"./images/pageTaro/bg_mob-old-1.png": "a07b",
	"./images/pageTaro/bg_mob-old.png": "8677",
	"./images/pageTaro/bg_mob.png": "f05e",
	"./images/pageTaro/cards_back-old-1.png": "dd72",
	"./images/pageTaro/cards_back-old-3.png": "98e6",
	"./images/pageTaro/cards_back-old.png": "0b6e",
	"./images/pageTaro/cards_back-pold-2.png": "a475",
	"./images/pageTaro/cards_back.png": "cbbb",
	"./images/pageTaro/test_card.png": "4822",
	"./images/patterns/gf-pattern.svg": "7193",
	"./images/payments/apple-pay.svg": "c6c9",
	"./images/payments/googlepay-logo-full.svg": "854e",
	"./images/payments/sbp-pay.svg": "ee35",
	"./images/phone.svg": "cf63",
	"./images/photo-null.png": "77d8",
	"./images/preorder/preorder-mob.jpg": "d969",
	"./images/preorder/preorder.jpg": "36d8",
	"./images/shadow-triangle-grey.svg": "7d6d",
	"./images/simple-image/1.png": "c79f",
	"./images/socials/facebook.svg": "f25a",
	"./images/socials/instagram.svg": "0496",
	"./images/socials/ok.svg": "58ca",
	"./images/socials/telegram.svg": "cbd2",
	"./images/socials/vk.svg": "2ad0",
	"./images/socials/whatsapp.svg": "769c",
	"./images/star_extrabonus.png": "4ec6",
	"./images/targetsSliderPromoBanner/4rYSRevQRYNwiXf7.jpeg": "f7ec",
	"./images/targetsSliderPromoBanner/JuKw8uim72L5xIn5.jpeg": "86ea",
	"./images/targetsSliderPromoBanner/cf4DQqkdoEKIumcO.jpeg": "3f60",
	"./images/targetsSliderPromoBanner/eFPAOkzzWIYt63GX.jpeg": "09a4",
	"./images/targetsSliderPromoBanner/ir3NcD9Wmmq3waSP.jpeg": "f5e6",
	"./images/targetsSliderPromoBanner/w14B2TEN9azpUV7k.jpeg": "00c5",
	"./images/tariffs/desktop/economy.png": "70a2",
	"./images/tariffs/desktop/personal.png": "0767",
	"./images/tariffs/desktop/save.png": "fab8",
	"./images/tariffs/personal.png": "b036",
	"./images/tariffs/save.png": "5e90",
	"./images/tariffs/welcome.png": "8059",
	"./images/temp/slide_1_comp.jpg": "80ee",
	"./images/temp/slide_1_comp_mob.jpg": "e12b8",
	"./images/temp/slide_2_comp.jpg": "5cac",
	"./images/temp/slide_2_comp_mob.jpg": "8f91",
	"./images/temp/slide_3_comp.jpg": "9604",
	"./images/temp/slide_3_comp_mob.jpg": "3556",
	"./images/toast/error-subtract.svg": "46e8",
	"./images/toast/success-subtract.svg": "b2e8",
	"./images/toast/warning-subtract.svg": "1040",
	"./logo.png": "cf05",
	"./sprites/add_prefs.svg": "1bd3",
	"./sprites/address_pin.svg": "d2c9",
	"./sprites/alert-rounded-red.svg": "f981",
	"./sprites/alert.svg": "aa06",
	"./sprites/all-banks.svg": "3e27",
	"./sprites/arrow-curve-right.svg": "f5c8",
	"./sprites/arrow-down-full.svg": "6e5c",
	"./sprites/arrow-down-no-tail.svg": "7be0",
	"./sprites/arrow-down.svg": "9921",
	"./sprites/arrow-left-2.svg": "13dd",
	"./sprites/arrow-left.svg": "8055",
	"./sprites/arrow-m-left.svg": "4ff7",
	"./sprites/arrow-medium-left.svg": "d5d8",
	"./sprites/arrow-right-new.svg": "f5d3",
	"./sprites/arrow-right-small.svg": "6ee1",
	"./sprites/arrow-right.svg": "e99f",
	"./sprites/arrow-top-large.svg": "a1bb",
	"./sprites/arrow-top-small.svg": "2f7e",
	"./sprites/arrow-triangle-bottom-2.svg": "10bd",
	"./sprites/arrow-triangle-bottom.svg": "e147",
	"./sprites/arrow-triangle-top.svg": "cac0",
	"./sprites/avatar.svg": "1711",
	"./sprites/bell.svg": "75e7",
	"./sprites/bin-small-filled.svg": "fbc4",
	"./sprites/calendar-2.svg": "cc80",
	"./sprites/calendar-3.svg": "55bf",
	"./sprites/calendar.svg": "481b",
	"./sprites/call-courier.svg": "a743",
	"./sprites/call-me.svg": "10b1",
	"./sprites/chat.svg": "74fd",
	"./sprites/check-rounded.svg": "ee0e",
	"./sprites/check.svg": "23b1",
	"./sprites/check_circle.svg": "a2ec",
	"./sprites/chevron-left-no-tail.svg": "7c3a",
	"./sprites/chevron-right-no-tail.svg": "b275",
	"./sprites/chevron_down_fixed.svg": "961f",
	"./sprites/chevron_down_medium.svg": "2c36",
	"./sprites/chevron_down_small.svg": "c6c95",
	"./sprites/chevron_right.svg": "7383",
	"./sprites/chevron_right_large.svg": "8620",
	"./sprites/circle-loader.svg": "1d54",
	"./sprites/city-selector.svg": "3e2b",
	"./sprites/clock.svg": "9dbb",
	"./sprites/cross-copy-3.svg": "391c",
	"./sprites/cross-smooth.svg": "020e",
	"./sprites/cross.svg": "cfe3",
	"./sprites/curly-arrow-small.svg": "188f",
	"./sprites/cutlery.svg": "25ce",
	"./sprites/dashboard.svg": "d725",
	"./sprites/delivery-car-stroke.svg": "0cee",
	"./sprites/delivery-car.svg": "3198",
	"./sprites/delivery-check.svg": "e7ab",
	"./sprites/discount.svg": "a487",
	"./sprites/gf_about.svg": "d0b4",
	"./sprites/gf_aeroflot.svg": "d6d8",
	"./sprites/gf_books.svg": "8a06",
	"./sprites/gf_calendar.svg": "21ca",
	"./sprites/gf_fitting.svg": "2fc3",
	"./sprites/gf_muscule.svg": "c6ac",
	"./sprites/gf_payment.svg": "3e10",
	"./sprites/gf_price copy.svg": "a1e0",
	"./sprites/gf_price.svg": "6ece",
	"./sprites/gf_promo.svg": "86e8",
	"./sprites/gf_reduce.svg": "4fb7",
	"./sprites/gf_storage copy.svg": "26de",
	"./sprites/gf_storage.svg": "9905",
	"./sprites/gf_waist.svg": "86ec",
	"./sprites/gift.svg": "007e",
	"./sprites/heart-rating.svg": "75cf",
	"./sprites/heart2.svg": "796e",
	"./sprites/ic-tick.svg": "d5a3",
	"./sprites/icon-chevron-down-large.svg": "3263",
	"./sprites/icon-close-small.svg": "fd6c",
	"./sprites/icon-user.svg": "4af2",
	"./sprites/info-rounded-2.svg": "ce10",
	"./sprites/info-rounded-small.svg": "dd24",
	"./sprites/info-rounded.svg": "8be5",
	"./sprites/info.svg": "72d3",
	"./sprites/intersect.svg": "3852",
	"./sprites/lightning.svg": "bb8c",
	"./sprites/lk-loyalty.svg": "6d1f",
	"./sprites/lock.svg": "59ca",
	"./sprites/logo-one-line_simple.svg": "2d17",
	"./sprites/logo.svg": "7afa",
	"./sprites/logout.svg": "cc51",
	"./sprites/minus.svg": "5242",
	"./sprites/navbar-cart.svg": "6d0a",
	"./sprites/navbar-favorites.svg": "cd75",
	"./sprites/navbar-invite.svg": "286e",
	"./sprites/navbar-logout.svg": "f591",
	"./sprites/navbar-new-order.svg": "ce94",
	"./sprites/navbar-orders.svg": "7f97",
	"./sprites/navbar-settings.svg": "c2f6",
	"./sprites/navbar-subscribe.svg": "d8c8",
	"./sprites/navbar-wallet.svg": "f35d",
	"./sprites/new-order.svg": "330c",
	"./sprites/notifications-error-xl.svg": "09c4",
	"./sprites/pacman.svg": "159bb",
	"./sprites/page_deliveries.svg": "b36b",
	"./sprites/page_menu.svg": "6e3c",
	"./sprites/page_preferences.svg": "56d1",
	"./sprites/page_settings.svg": "b9f9",
	"./sprites/pay-aeroflot.svg": "5e25",
	"./sprites/pay-apple.svg": "c779",
	"./sprites/pay-by-cash.svg": "ab0a",
	"./sprites/pay-card.svg": "9741",
	"./sprites/pay-google.svg": "6dd9",
	"./sprites/pen.svg": "6db6",
	"./sprites/percent.svg": "e891",
	"./sprites/phone.svg": "e58f",
	"./sprites/plus.svg": "ecea",
	"./sprites/promocode.svg": "f27f",
	"./sprites/question-hover.svg": "d213",
	"./sprites/question-normal.svg": "f803",
	"./sprites/question.svg": "d49f",
	"./sprites/right.svg": "cb8d",
	"./sprites/rouble-rounded.svg": "90fd",
	"./sprites/ruble-rounded.svg": "0646",
	"./sprites/settings.svg": "408a",
	"./sprites/telegram.svg": "a9f0",
	"./sprites/thicc-cross.svg": "c59c",
	"./sprites/thumbs-down-ff.svg": "f778",
	"./sprites/thumbs-down.svg": "fb1e",
	"./sprites/thumbup.svg": "ec8a",
	"./sprites/trash-2.svg": "e5b9",
	"./sprites/trash.svg": "ad29",
	"./sprites/weigher.svg": "3118",
	"./sprites/whatsapp.svg": "32a1",
	"./styles/_c-btn.scss": "c1fb",
	"./styles/_comm-channel.scss": "db42",
	"./styles/_core-radio.scss": "3392",
	"./styles/_filters.scss": "9b54",
	"./styles/_general.scss": "ca8c",
	"./styles/_new-order-menu.scss": "d80e",
	"./styles/_pack-card.scss": "bcae",
	"./styles/_pay-cards.scss": "c55c",
	"./styles/_payment-card.scss": "10cc",
	"./styles/_promocode.scss": "28e1",
	"./styles/_reset.scss": "ab37",
	"./styles/_select.scss": "9cbd",
	"./styles/_tooltip.scss": "6eb3",
	"./styles/_vcp-button.scss": "bb37",
	"./styles/app.scss": "a899",
	"./styles/core/_colors.scss": "ae04",
	"./styles/core/_font.scss": "345c",
	"./styles/core/_layout.scss": "b4eb",
	"./styles/core/_mixins.scss": "2e07",
	"./styles/core/_reset.scss": "e026",
	"./styles/core/_skeleton.scss": "a1f1",
	"./styles/core/_toast.scss": "2ea4",
	"./styles/core/_transitions.scss": "571f",
	"./styles/core/_typography.scss": "5fd9",
	"./styles/core/grid/_grid.scss": "755e",
	"./styles/core/grid/_mixins.scss": "ff35",
	"./styles/core/grid/_settings.scss": "abc7",
	"./styles/prepend.scss": "9166"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";